import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {UserRoles} from '../../../../enums/general-enums';
import {CheckActiveRoleModule} from '../../../../pipes/check-active-role/check-active-role.module';

@Component({
  selector: 'app-lister',
  standalone: true,
  imports: [NgIf, TranslateModule, CheckActiveRoleModule],
  templateUrl: './lister.component.html',
})
export class ListerComponent {
  @Input() lister: any;

  protected readonly UserRoles = UserRoles;
}
